import { Effects } from 'chessboard/plugins/effects/renderer/types';

export const mate = `<g id="mate">
    <path class="${Effects.ClassNames.Shadow}" opacity="0.3" d="M9,.5a9,9,0,1,0,9,9A9,9,0,0,0,9,.5Z"></path>
    <path class="${Effects.ClassNames.Background}" fill="#ec6250" d="M9,0a9,9,0,1,0,9,9A9,9,0,0,0,9,0Z"></path>
    <g>
      <g class="${Effects.ClassNames.ComponentShadow}" opacity="0.2">
        <path d="M11.44,8.61h1.74l.1-1.55H11.54l.18-2.78H10.17L10,7.06H8.31l.18-2.78H6.94L6.76,7.06H5l-.1,1.55H6.66l-.11,1.68H4.82l-.1,1.55H6.46l-.18,2.78H7.83L8,11.84H9.69l-.18,2.78h1.55l.18-2.78H13l.1-1.55H11.34ZM8.11,10.29l.1-1.68H9.89l-.1,1.68Z"></path>
      </g>
      <path class="${Effects.ClassNames.Component}" fill="#fff" d="M11.44,8.11h1.74l.1-1.55H11.54l.18-2.78H10.17L10,6.56H8.31l.18-2.78H6.94L6.76,6.56H5l-.1,1.55H6.66L6.55,9.79H4.82l-.1,1.55H6.46l-.18,2.78H7.83L8,11.34H9.69l-.18,2.78h1.55l.18-2.78H13l.1-1.55H11.34ZM8.11,9.79l.1-1.68H9.89l-.1,1.68Z"></path>
    </g>
  </g>`;
